module.exports = __webpack_public_path__ + "img/a279b22.png";